export default {
  colors: {
    inherit: 'inherit',

    white: '#FFFFFF',
    deepSea100: '#042341',
    deepSea90: '#2C435E',
    deepSea80: '#364E6A',
    deepSea70: '#4E6178',
    deepSea60: '#6F8298',
    deepSea50: '#8FA1B4',
    deepSea40: '#B0BDCA',
    deepSea30: '#D3DCE4',
    deepSea20: '#EDF0F2',
    deepSea10: '#F9FAFB',
    sea100: '#1E5093',
    sea90: '#36639F',
    sea80: '#4E76AB',
    sea70: '#6789B7',
    sea60: '#7F9CC3',
    sea50: '#97AFCF',
    sea40: '#B0C2DB',
    sea30: '#C8D5E7',
    sea20: '#ECF2F8',
    seafoam100: '#397676',
    seafoam90: '#4E8585',
    seafoam80: '#639494',
    seafoam70: '#79A3A3',
    seafoam50: '#A4C2C1',
    seafoam30: '#CFE0DF',
    seafoam20: '#F0F6F4',
    seafoam10: '#FAFFFD',
    stone100: '#252838',
    stone90: '#3C3F4D',
    stone80: '#545662',
    stone70: '#6B6D78',
    stone60: '#83848D',
    stone50: '#9A9CA3',
    stone40: '#B2B3B8',
    stone30: '#C9CACE',
    stone20: '#E1E1E3',
    stone10: '#F9F9F9',
    clay100: '#AE5451',
    clay80: '#C07876',
    clay50: '#DBAFAE',
    clay20: '#F6E6E6',
    seaweed100: '#3F4F56',
    seaweed80: '#677479',
    seaweed70: '#7B878B',
    seaweed30: '#CBD2D3',
    starfish100: '#D35955',
    starfish90: '#D76966',
    starfish80: '#DB7A77',
    starfish70: '#E08A88',
    starfish60: '#E49B99',
    starfish40: '#EDBCBB',
    starfish30: '#F1CDCC',
    sunflower100: '#DCBA49',
    sunflower90: '#DCBA49',
    sunflower70: '#BB9000',
    sunflower60: '#EAD591',
    sunflower30: '#F4EAC8',
    sunflower20: '#F8F1DA',
    sunflower10: '#FBF8EC',
    saffron70: '#E36D2C',
    saffron50: '#F28841',
    saffron40: '#F4A46A',
    saffron20: '#F9D1B3',
    lavender60: '#6171C2',
    lavender40: '#8B98CE',
  },
  fonts: {
    sourceCodePro: '"Source Code Pro", monospace',
  },
  // CODE: 28d11940: typography definitions
  fontSizes: {
    h1: '40px',
    h2: '32px',
    h3: '24px',
    h4: '20px',
    h5: '18px',
    h6: '16px',
    subtitle1: '14px',
    subtitle2: '14px',
    body1: '16px',
    body2: '14px',
    caption: '12px',
    caption2: '12px',
    overline: '12px',
    button: '14px',
    labelSmall: '9px',
    sourceCodePro: '14px',
  },
  lineHeights: {
    h1: '46px',
    h2: '40px',
    h3: '30px',
    h4: '26px',
    h5: '23px',
    h6: '20px',
    subtitle1: '20px',
    subtitle2: '18px',
    body1: '22px',
    body2: '20px',
    caption: '14px',
    caption2: '14px',
    overline: '18px',
    button: '18px',
    labelSmall: '14px',
    heading: '18px',
    panelheading: '23px',
    sourceCodePro: '20px',
  },
  space: [0, 4, 8, 16, 32, 48],
  breakpoints: ['641px', '992px', '1264px'], // CODE: b4061f07, if these change, update the @media queries in site.variables
  misc: {
    panelIconXSpacing: '10px',
    panelIconFontSize: '16px',
  },
};
